import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { CustomerDto } from '../../../models/trofaco/customerDto';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {

    constructor(private request: RequestService) {
    }

    async getCustomers() {
        let result = await this.request.getApi<CustomerDto[]>('customers');
        return result.data;
    }

    async deleteCustomer(id: string): Promise<string> {
        let result = await this.request.delete('customers/delete-customer?customerId=' + id);
        return result.data;
    }

    async removeLogo(id: string): Promise<void> {
        await this.request.delete('customers/remove-logo?customerId=' + id);
    }

    async getById(id: string): Promise<CustomerDto> {
        let result = await this.request.getApi<CustomerDto>('customers/' + id);
        return result.data;
    }

    async create(customer: CustomerDto): Promise<string> {
        let result = await this.request.post('customers/create-customer', customer);
        if (result.errors)
            return null;
            
        return result.data;
    }

    async update(customer: CustomerDto): Promise<void> {
        await this.request.patch('customers/update-customer', customer);
    }

    updateLogo(file: File, customerId: string) {
        let formData = new FormData();
        formData.append('logo', file, file.name);
        formData.append('customerId', customerId);
        return this.request.post('customers/upload-logo', formData);
    }

    async getCountries() {
        let result = await this.request.getApi<string[]>('customers/countries');
        return result.data;
    }

    async getCustomersName() {
        let result = await this.request.getApi<string[]>('customers/get-customers-name');
        return result.data;
    }


}
